//Please add the language resource
const orderImport = {
  shipperName: 'shipperName',
  companyName: 'companyName',
  importFileName: 'importFileName',
  processFileName: 'processFileName',
  orderCount: 'orderCount',
  dealStatus: 'dealStatus',
  dealTime: 'dealTime',
  dealResult: 'dealResult',
  createTime: 'createTime',
  creator: 'creator',
  msg: {}
};
export default orderImport




// WEBPACK FOOTER //
// ./src/page/order/orderImport/lang/orderImport.en.js